import { ID_HELP_SEARCH } from './constants';

export const getPortalSearch = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return document.getElementById(ID_HELP_SEARCH);
};
